var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwStep4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9005 25.8333H63.5758L54.1089 17.2209H11.6089L2.13068 25.8221H3.92963C2.50172 26.2156 1.43359 27.5086 1.43359 29.0602V60.5417C1.43359 62.3968 2.95145 63.9147 4.80661 63.9147H61.0235C62.8787 63.9147 64.3966 62.3968 64.3966 60.5417V29.0602C64.3853 27.5198 63.3284 26.2268 61.9005 25.8333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2661 36.9418V17.2209L63.5756 25.8333C63.5756 25.8333 65.5095 26.8227 64.3852 29.0714C63.2608 31.3201 54.2661 36.9418 54.2661 36.9418Z",
    fill: "#63C7C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5417 36.9418V17.2209L2.24337 25.8333C2.24337 25.8333 0.309508 26.8227 1.43385 29.0714C2.55819 31.3201 11.5417 36.9418 11.5417 36.9418Z",
    fill: "#63C7C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.609 17.0972L2.13078 25.8333C0.45552 27.3849 0.657902 30.0833 2.54679 31.365L28.89 49.2308C31.2961 50.8611 34.4443 50.8611 36.8391 49.2308L63.1824 31.3875C65.0825 30.1058 65.2736 27.3736 63.5759 25.8333L54.109 17.2208",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.983887 28.3069V60.9802C0.983887 62.9815 2.5692 64.6118 4.52555 64.6118H61.1922C63.1486 64.6118 64.7339 62.9815 64.7339 60.9802V28.3069",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0293 63.5661L21.4241 44.1713",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2935 44.1826L63.6771 63.5662",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6089 37.2678V4.40342C11.6089 2.44707 13.1942 0.861755 15.1506 0.861755H50.5672C52.5236 0.861755 54.1089 2.44707 54.1089 4.40342V37.2678",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6089 37.2678V4.40342C11.6089 2.44707 13.1942 0.861755 15.1506 0.861755H50.5672C52.5236 0.861755 54.1089 2.44707 54.1089 4.40342V37.2678",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5031 20.459C22.1552 21.7969 23.0659 22.8876 23.8867 23.7758C25.3708 25.4061 27.0573 26.8677 28.6876 28.2731C29.5646 29.0264 30.4416 29.7797 31.2848 30.5668C31.8358 31.084 32.4429 31.3426 33.0613 31.3426C33.6797 31.3426 34.3093 31.084 34.894 30.5555C36.513 29.1051 38.1208 27.666 39.7286 26.2044C41.4039 24.6865 42.6407 23.3485 43.6413 21.9993C44.8444 20.369 45.3503 18.5701 45.1704 16.6475C44.968 14.6012 43.9561 13.0383 42.2359 12.1164C39.144 10.4749 35.5011 10.8009 33.0276 12.8472C31.1162 11.2619 28.7214 10.7222 26.0679 11.3069C24.1565 11.7229 22.7736 12.5774 21.8629 13.9041C21.3569 14.6349 21.1433 15.4219 20.9747 16.0516L20.9297 18.4239L20.9971 18.8737C21.0983 19.3684 21.2333 19.9193 21.5031 20.459Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep4);
export default __webpack_public_path__ + "static/media/ww-step4.27c7e643.svg";
export { ForwardRef as ReactComponent };